function checkhost(sHost) {
    const href = sHost || window.location.href;
    let host;
    let path;
    let imagePath;
    /* istanbul ignore next */
    if (href.search('test1') !== -1) {
        host = 'test1';
    } else if (href.search('test2') !== -1) {
        host = 'test2';
    } else if (href.search('test3') !== -1) {
        host = 'test3';
    } else if (href.search('test4') !== -1) {
        host = 'test4';
    }

    /* istanbul ignore next */
    if (host) {
        path = `dt-${host}.jcpenney.com`;
    } else if (href.search('localhost') !== -1) {
        path = 'localhost';
    } else {
        path = 'www.jcpenney.com';
    }

    /* istanbul ignore next */
    if (path === 'localhost') {
        imagePath = '';
    } else {
        imagePath = `//${path}`;
    }

    return { path, host, imagePath };
}

export default checkhost;
